import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { ResponseHelperService } from 'src/app/services/helpers/response-helper.service';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RedemptionService } from 'src/app/services/redemption.service';
import { AddressModel } from 'src/app/data/model';

@Component({
  selector: 'app-redemption-address-modal',
  templateUrl: './redemption-address-modal.component.html',
  styleUrls: ['./redemption-address-modal.component.scss'],
})
export class RedemptionAddressModalComponent implements OnInit {
  @Output() public successEvent: EventEmitter<any> = new EventEmitter();
  @Input() public address: AddressModel = new AddressModel();
  @Input() public addressData: any = {};
  @Input() public txnId: number;
  faTimes = faTimes;
  faSave = faSave;
  addressForm: UntypedFormGroup;
  errorMsg: string;
  selectedState: string;
  isDisabledSave: boolean;

  @ViewChild('states') states;
  @ViewChild('statesRef') statesRef: ElementRef;
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.statesRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.handleOutsideAutocomplete();
    }
  }
  @HostListener('document:keydown', ['$event'])
  onTabPressed(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      const focusedInside = this.statesRef.nativeElement.contains(
        document.activeElement
      );
      if (!focusedInside) {
        this.handleOutsideAutocomplete();
      }
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private redemptionService: RedemptionService,
    private ressponseHelperService: ResponseHelperService,
    private modalHelper: NgbModal
  ) {}

  ngOnInit(): void {
    this.addressData.states = this.addressData.states.map((state) => ({
      ...state,
      displayText: `${state.name} (${state.shortName})`,
    }));
    this.addressForm = this.formBuilder.group({
      address1: [''],
      address2: [''],
      state: [''],
      zip: [''],
      country: [''],
      city: [''],
    });

    this.redemptionService.getRedemption(this.txnId).subscribe((resp: any) => {
      this.address = resp.entity;
      this.selectedState = this.formatStateCode(this.address.state);
      this.addressForm = this.formBuilder.group({
        address1: [this.address.address1],
        address2: [this.address.address2],
        state: [this.formatStateCode(this.address.state)],
        zip: [this.address.zip],
        country: [this.address.country],
        city: [this.address.city],
      });
    });
  }

  ok(): void {
    const value = this.addressForm.value;
    const state = typeof value.state === 'string' ? value.state : this.formatStateCode(value.state.code);
    this.redemptionService
      .updateRedemptionAddress(this.address.id, { ...value, state: state })
      .subscribe(
        (data: any) => {
          this.ressponseHelperService.success(
            'Redemption successfully updated',
            true
          );
          this.successEvent.emit('success');
        },
        (data: any) => {
          this.ressponseHelperService.error(this, data.error.error);
        }
      );
  }

  cancel(): void {
    this.modalHelper.dismissAll();
  }

  clearErrorMessage(): void {
    this.errorMsg = '';
  }

  focusStates(): void {
    this.states.close();
  }

  onInputChanged(input: string) {
    this.addressForm.get('state')?.setValue(input);
    this.isDisabledSave = true;
  }

  onStateSelected(event: any) {
    const value = this.formatStateCode(event.code);
    this.selectedState = value;
    this.addressForm.patchValue({ state: value });
    this.addressForm.get('state')?.setErrors(null);
  }

  handleOutsideAutocomplete() {
    const control = this.addressForm.get('state');
    const inputValue = control.value;
    let isValid: boolean;
    if (typeof inputValue === 'string') {
      isValid = !(this.selectedState && inputValue === this.selectedState);
    } else {
      isValid = !(
        this.selectedState &&
        this.formatStateCode(inputValue?.code) === this.selectedState
      );
    }
    if (isValid) {
      control?.setErrors({ invalidState: true });
      control?.markAsTouched();
    } else {
      control?.setErrors(null);
      this.isDisabledSave = false;
    }
  }

  formatStateCode(stateCode: string): string {
    if (stateCode) {
      return stateCode.includes('-') ? stateCode.split('-')[1] : stateCode;
    }
    return stateCode;
  }
}
